import {styled} from 'styled-components';
import {Table, TableColumnsType} from 'antd';
import {FC} from 'react';
import {IReportAbcTable, reportsSelect} from '../../../../entities/reports';
import {useSelector} from 'react-redux';
import {textMixin} from '../../../../styles/mixins';
import {colors} from '../../../../styles';
import {PuffLoader} from 'react-spinners';
import {cssOverride} from '../../../../utils/const';
import {createReportAbcColumns} from './ui/createReportAbcColumns';

const TableReportAbc: FC = () => {
    const {reportAbc, loading} = useSelector(reportsSelect);

    if (!reportAbc) {
        return <PuffLoader color={colors.loader} cssOverride={cssOverride} />;
    }

    const columns: TableColumnsType<IReportAbcTable> | JSX.Element =
        createReportAbcColumns({
            columns: reportAbc?.columns,
        });

    return (
        <StyledTable>
            <Table
                pagination={false}
                scroll={{x: 700, y: 600}}
                dataSource={reportAbc?.table}
                loading={loading === 'loading'}
                columns={columns as TableColumnsType<IReportAbcTable>}
                size="small"
                rowKey="Блюда"
            />
        </StyledTable>
    );
};

export default TableReportAbc;

const StyledTable = styled.div`
    .ant-table-thead > tr > th {
        background-color: ${colors.tableHeadBg};
        ${textMixin({
            fontSize: '14px',
            fontWeight: 600,
        })};
        line-height: 16.8px;
        text-align: left;
        height: 45px;
        padding-right: 1.1em !important;
    }

    .ant-table-footer {
        background-color: ${colors.tableHeadBg};
        ${textMixin({
            fontSize: '14px',
            fontWeight: 600,
        })};
        line-height: 16.8px;
        text-align: left;
    }

    table > tbody > tr > td {
        background-color: ${colors.cleanWhite};
        border: 1px solid #efefef;
        color: ${colors.grey};
        ${textMixin({
            fontSize: '14px',
            fontWeight: 400,
        })};
        line-height: 16.8px;
        text-align: left;
        height: 30px;
    }

    .ant-table-summary {
        background-color: ${colors.tableHeadBg};
        ${textMixin({
            fontSize: '14px',
            fontWeight: 600,
        })};
        line-height: 16.8px;
        height: 45px;
        tr > td:first-child {
            border-bottom-left-radius: 8px;
        }

        tr > td:last-child {
            border-bottom-right-radius: 8px;
        }
    }
    .ant-table-summary .ant-table-cell {
        padding-top: 4px !important;
        padding-bottom: 4px !important;
    }
`;
